<template>
  <div class="gt-member-picker-panel">
    <div v-if="pluginsShowList.length">
      <el-form :label-width="labelWidth" :size="formSize" :disabled="disabled">
        <el-form-item :label="$t('Root.MemberPicker.selected_members')">
          <el-radio-group v-model="activePlugin">
            <el-radio
              v-for="item in pluginsShowList"
              :key="item.id"
              :label="item.id"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <component
        v-show="item.id === activePlugin"
        v-for="item in pluginsShowList"
        :key="item.id"
        :is="item.component"
        :initData="item.id === defaultActive ? initData : []"
        :required="required"
        :id="item.id"
        :label="item.label"
        :disabled="disabled"
        @registerSelf="registerPlugin"
      />
    </div>
  </div>
</template>

<script>
import ByTags from "./plugins/ByTags.vue";
import ByMobile from "./plugins/ByMobile.vue";
import ByUserID from "./plugins/ByUserID.vue";
// const TEMPLATE_MAP = {
//   tags: {
//     component: ByTags,
//     id: "tags",
//     label: i18nInstance.t("Root.Picker.ByTags")
//   },
//   mobile: {
//     component: ByMobile,
//     id: "mobile",
//     label: "By Mobile"
//   },
//   userID: {
//     component: ByUserID,
//     id: "userID",
//     label: "By User ID"
//   }
// };
// const ALL_SUPPORT_PLUGINS = Object.keys(TEMPLATE_MAP);
export default {
  name: "MemberPicker",

  provide() {
    return { labelWidth: this.labelWidth, master: this };
  },

  props: {
    plugins: {
      type: String,
      default: "tags mobile userID"
    },
    // 初始数据
    initData: {
      type: Array,
      default: () => {
        return [];
      }
    },

    labelWidth: {
      type: String,
      default: "210px"
    },

    formSize: {
      type: String,
      default: "small"
    },

    defaultActive: {
      type: [String, Number]
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    plugins: {
      handler: "getMethodList",
      immediate: true
    }
  },

  data() {
    return {
      pluginsShowList: [],
      activePlugin: "",
      TEMPLATE_MAP: {
        tags: {
          component: ByTags,
          id: "tags",
          label: this.$t("Root.Picker.ByTags")
        },
        mobile: {
          component: ByMobile,
          id: "mobile",
          label: this.$t("Root.Picker.ByMobile")
        },
        userID: {
          component: ByUserID,
          id: "userID",
          label: this.$t("Root.Picker.ByUserID")
        }
      }
    };
  },

  methods: {
    getMethodList(plugins) {
      let showList = plugins
        .split(" ")
        .filter(id => Object.keys(this.TEMPLATE_MAP).includes(id));

      this.activePlugin = plugins.includes(this.defaultActive)
        ? this.defaultActive
        : showList[0];

      this.pluginsShowList = showList.map(pluginID => {
        return this.TEMPLATE_MAP[pluginID];
      });
    },

    // 设置默认激活的plugin
    setDefaultActivePlugin(id) {
      this.activePlugin =
        id || this.pluginsShowList.length ? this.pluginsShowList[0].id : "";
    },

    // 注册plugin
    registerPlugin(data) {
      const { label, id, validator } = data;

      // 防止重复注册
      let index = this.pluginsShowList.findIndex(item => item.id === id);
      if (index === -1) {
        this.pluginsShowList.push({ label, id, validator });
      } else {
        this.$set(this.pluginsShowList[index], "validator", validator);
      }
    },

    // 触发表单验证
    async submit() {
      const { activePlugin } = this;

      let plugin = this.pluginsShowList.find(({ id }) => id === activePlugin);

      if (plugin && plugin.validator) {
        let data = await plugin.validator();

        console.dir({
          active: activePlugin,
          data
        });

        return {
          active: activePlugin,
          data
        };
      }
    }
  }
};
</script>

<style lang="scss"></style>
